import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store/auth.store.js';
import type { UserRole } from '@atomfit/shared';

interface Props {
  children: React.ReactNode;
  requireRole?: UserRole;
  requireAccount?: boolean;
}

export function ProtectedRoute({ children, requireRole, requireAccount }: Props) {
  const location = useLocation();
  const { accessToken, role, account } = useAuthStore();
  const redirect = `${location.pathname}${location.search}${location.hash}`;
  const loginPath = `/login?redirect=${encodeURIComponent(redirect)}`;

  if (!accessToken) return <Navigate to={loginPath} replace />;

  if (requireAccount && !account) return <Navigate to={loginPath} replace />;

  const ownerConsoleRole =
    requireRole === 'OWNER_ADMIN' &&
    (role === 'OWNER_ADMIN' || role === 'PLATFORM_ADMIN' || role === 'GYM_STAFF');

  if (requireRole && !ownerConsoleRole && role !== requireRole && role !== 'PLATFORM_ADMIN') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
